/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from "classnames";
import Tooltip from "PFComponents/tooltip/tooltip";
import React, { MouseEvent, useState } from "react";

import css from "../bars.module.scss";
import BookingTooltipContent from "./booking_tooltip_content";

interface BookingBarEdgeProps {
  className: string;
  onMouseDown?: (event: MouseEvent) => void;
  isDragged: boolean;
  startDate?: string;
  endDate?: string;
}

const BookingBarEdge = ({
  className,
  onMouseDown,
  isDragged,
  startDate,
  endDate
}: BookingBarEdgeProps): JSX.Element => {
  const [hover, setHover] = useState(false);
  return (
    <Tooltip
      content={<BookingTooltipContent start={startDate} end={endDate} />}
      placement="top"
      enableVisible
      visible={isDragged}
    >
      <div
        className={classNames(className, css.bookingBarEdge, {
          [css.active]: hover || isDragged,
          [css.cursorResizing]: hover || isDragged
        })}
        onMouseDown={onMouseDown}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <div className={css.bookingBarEdgeIndicator} />
      </div>
    </Tooltip>
  );
};

export default BookingBarEdge;
